import { foldText } from '../text/normalize.js';
const STOP_WORDS = new Set();
for (const word of [
    'fresh',
    'frisch',
    'frische',
    'frischer',
    'frisches',
    'large',
    'small',
    'medium',
    'groß',
    'große',
    'großer',
    'klein',
    'kleine',
    'kleiner',
    'mittelgroß',
    'mittelgroße',
    'ripe',
    'reif',
    'reife',
    'of',
    'the',
    'a',
    'an',
    'some',
    'etwas',
    'ein',
    'eine',
    'einige',
    'organic',
    'bio',
    'chopped',
    'diced',
    'sliced',
    'minced',
    'grated',
    'gehackt',
    'gewürfelt',
    'geschnitten',
    'gerieben',
    'fein',
    'grob',
    'finely',
    'roughly',
    'coarsely',
    'peeled',
    'geschält',
    'optional',
]) {
    STOP_WORDS.add(foldText(word));
}
const PLURAL_RULES = [
    [/(tomato|potato)es$/, '$1'],
    [/ies$/, 'y'],
    [/(ch|sh|ss|x|z)es$/, '$1'],
    [/([^s])s$/, '$1'],
];
function singularize(word) {
    if (word.length <= 3)
        return word;
    for (const [re, replacement] of PLURAL_RULES) {
        if (re.test(word))
            return word.replace(re, replacement);
    }
    return word;
}
/**
 * Normalized ingredient key used for duplicate detection, pantry matching and
 * shopping-list merging: lowercased, accent-folded, stop words and simple plurals removed.
 * Not shown to users.
 */
export function normalizeIngredientName(name) {
    const folded = foldText(name)
        .replace(/\(.*?\)/g, ' ')
        .replace(/[^a-z0-9\s-]/g, ' ')
        .split(/\s+/)
        .filter((w) => w && !STOP_WORDS.has(w))
        .map(singularize);
    return folded.join(' ').trim();
}
//# sourceMappingURL=normalize-name.js.map